import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {handleImageUrl, slugify} from "../../helpers";
import {LangContext} from "../../App";

const HotelsListItem = ({tour,path,i}) => {
    const lang = useContext(LangContext)
    const slug = slugify(tour?.title || '')
    return (
        <div className={`hotel-list-item ${i%2 === 0 ? 'flex-row-reverse' : ''}`}>
            <div className="text-aside">
                <h3>{tour.title}</h3>
                <p>{tour.description}</p>
                <Link to={`/${lang}/${path}/${tour.id}/${slug}`} className='rm-button'>read more</Link>
            </div>
            <div className="slider-aside">
                <div className='slider-image-wrapper' style={{borderRadius:'10px !important',overflow:'hidden'}}>
                    <img src={handleImageUrl(tour.thumbnail)} alt={tour.title} />
                </div>
            </div>
        </div>
    );
};

export default HotelsListItem;